module.exports = __webpack_public_path__ + "img/bg-6.f2339aad.webp";